import { render, staticRenderFns } from "./indexRobika.vue?vue&type=template&id=bd81e160&scoped=true"
import script from "./indexRobika.vue?vue&type=script&lang=js"
export * from "./indexRobika.vue?vue&type=script&lang=js"
import style0 from "./indexRobika.vue?vue&type=style&index=0&id=bd81e160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd81e160",
  null
  
)

export default component.exports